import { c as _c } from "react/compiler-runtime";
import { IcoLock16 } from '@onefootprint/icons';
import type { Entity } from '@onefootprint/request-types/dashboard';
import { LinkButton, LoadingSpinner } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useDocumentField from '@/entity/hooks/use-document-field';
import type { TransformedDocument } from '@/entity/hooks/use-documents';
import useDocumentsQueryParams from '@/entity/hooks/use-documents-query-params';
type DocumentActionProps = {
  entity: Entity;
  document: TransformedDocument;
  title: string;
};

/** The viewer opens from the page's vault, which owns it. */
const DocumentAction = t0 => {
  const $ = _c(21);
  const {
    entity,
    document,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.documents"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== entity) {
    t2 = {
      entity
    };
    $[1] = entity;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    getProps,
    isVaultLoaded
  } = useDocumentField(t2);
  const queryParams = useDocumentsQueryParams();
  const field = isVaultLoaded ? getProps(document) : undefined;
  if (field?.isDecrypted) {
    let t3;
    if ($[3] !== t || $[4] !== title) {
      t3 = t(_temp, {
        title
      });
      $[3] = t;
      $[4] = title;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== document.id || $[7] !== queryParams) {
      t4 = () => queryParams.push(document.id);
      $[6] = document.id;
      $[7] = queryParams;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t) {
      t5 = t(_temp2);
      $[9] = t;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
      t6 = <LinkButton variant="label-3" ariaLabel={t3} onClick={t4}>{t5}</LinkButton>;
      $[11] = t3;
      $[12] = t4;
      $[13] = t5;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  if (field?.isDecrypting) {
    let t3;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <LoadingSpinner size="compact" />;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    return t3;
  }
  let t3;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IcoLock16 color="tertiary" />;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t) {
    t4 = t(_temp3);
    $[17] = t;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t4) {
    t5 = <span className="inline-flex items-center gap-1.5 text-body-3 text-tertiary">{t3}{t4}</span>;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
export default DocumentAction;
function _temp($) {
  return $.viewDocument;
}
function _temp2($_0) {
  return $_0.view;
}
function _temp3($_1) {
  return $_1.encrypted;
}